/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Course_Status_Locked_SubInputs */

const en_course_status_locked_sub = /** @type {(inputs: Course_Status_Locked_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You cannot retry this course anymore. ${i?.reason}`)
};

const ja_course_status_locked_sub = /** @type {(inputs: Course_Status_Locked_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このコースはこれ以上再試行できません。${i?.reason}`)
};

const fr_course_status_locked_sub = /** @type {(inputs: Course_Status_Locked_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous ne pouvez plus réessayer ce cours. ${i?.reason}`)
};

const de_course_status_locked_sub = /** @type {(inputs: Course_Status_Locked_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du kannst diesen Kurs nicht mehr wiederholen. ${i?.reason}`)
};

/**
* | output |
* | --- |
* | "You cannot retry this course anymore. {reason}" |
*
* @param {Course_Status_Locked_SubInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_status_locked_sub = /** @type {((inputs: Course_Status_Locked_SubInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Status_Locked_SubInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_status_locked_sub(inputs)
	if (locale === "ja") return ja_course_status_locked_sub(inputs)
	if (locale === "fr") return fr_course_status_locked_sub(inputs)
	return de_course_status_locked_sub(inputs)
});